<template>
    <img
            class="ms-storage-image"
            :src="imageSrc"
            :width="computedWidth"
            :height="computedHeight"
            :alt="alt === null ? file.fileTitle : alt"
    >
</template>
<script>
    import FileAppResource from '@milestoneslabs/milestones-core-js/src/AppResources/FileAppResource';

    export default {
        name: 'StorageImage',
        props: {
            file: {
                type: FileAppResource,
                required: true
            },
            alt: {
                type: String,
                required: false,
                default: null
            },
            width: {
                type: [Number, String],
                required: false,
            },
            height: {
                type: [Number, String],
                required: false,
            },
            position: {
                type: String,
                required: false,
            },

            keepAspectRatio: {
                type: Boolean,
                default: false,
            },
        },
        data: () => ({
            pxWidth: null,
            pxHeight: null,
        }),
        computed: {
            imageSrc() {
                let src;

                src = window.env.MILESTONES_AUTH_HOST + '/public-file/' + this.file.uuid + '?';

                if (this.pxWidth) {
                    src = src + '&w=' + this.pxWidth;
                }
                if (this.pxHeight) {
                    src = src + '&h=' + this.pxHeight;
                }
                if (this.position) {
                    src = src + '&p=' + this.position;
                }

                if (this.keepAspectRatio) {
                    src = src + '&r=1';
                }

                return src;
            },

            computedWidth() {
                if(!this.pxWidth || this.keepAspectRatio){
                    return null;
                }

                return this.pxWidth;
            },

            computedHeight() {
                if(!this.pxHeight || this.keepAspectRatio){
                    return null;
                }

                return this.pxHeight;
            },
        },
        methods: {
            pxDimmensions(){
                if (this.width) {
                    const width = this.convertValueToPixels(this.width);
                    if (!isNaN(width)) {
                        this.pxWidth = width;
                    } else {
                        this.pxWidth = null;
                    }
                }
                if (this.height) {
                    const height = this.convertValueToPixels(this.height);
                    if (!isNaN(height)) {
                        this.pxHeight = height;
                    } else {
                        this.pxHeight = null;
                    }
                }
            }
        },
        beforeMount() {
            this.pxDimmensions();
        },
        watch: {
            width: function(to, from){
                this.pxDimmensions();
            },
            height: function(to, from){
                this.pxDimmensions();
            },
        }
    };
</script>
